import { useEffect, useState } from "react";
import DynamicDownloadBtnSection from "../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection";
import "./Nirf.scss";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import { toast } from "react-toastify";

const Nirf = () => {

  const { backendUrl } = useContext(AppContext);
  const [allNirfs, setAllNirfs] = useState([]);
   let errorShown = false;

  async function fetchAllNirfs() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllNirfs`);
      if (data.success) {
        setAllNirfs(data || []);
      } 
      errorShown = false;  
    } catch (error) {
      if (errorShown) return;
            errorShown = true;
      if (error.response && error.response.status === 503) {
                      toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                  }
                  else if (!navigator.onLine) {
                      toast.error("🚫 No internet connection. Please check your network.");
                  }
      
                  else if (error.request && !error.response) {
                      toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                  }
                  else 
                  {
                      console.error("Unexpected error:", error);
                      toast.error("Something went wrong.");
                  }
    }
  }

  useEffect(() => {
    fetchAllNirfs();
  }, []);

  const content = allNirfs?.reports
    ?.filter(item => item.isActive)
    .map(item => ({
      filename: item.filename,
      data: item.data,
      contentType: item.contentType,
    })) || [];

  return (
    <section className="nirfMainContainer">
      <header className="nirfHeader">
        <h2>NIRF</h2>
      </header>
      <DynamicDownloadBtnSection
        items={content}
        yearFontSize={1.25}
      />
    </section>
  );
};

export default Nirf;
